import { Injectable } from '@angular/core';
import {
  ConfirmResponse,
  LoginRequest,
  RegisterRequest,
  ResetPasswordRequest,
  UserDto,
} from '@app/models';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';

const AUTH_PREFIX = '/auth';

@Injectable({ providedIn: 'root' })
export class AuthApi extends ApiService {
  public signIn$(body: LoginRequest): Observable<UserDto> {
    return this.post(`${AUTH_PREFIX}/login`, body) as Observable<UserDto>;
  }

  public registerUser$(body: RegisterRequest): Observable<ConfirmResponse> {
    return this.post(`${AUTH_PREFIX}/register`, body);
  }

  public activateUser(body: ResetPasswordRequest): Observable<UserDto> {
    return this.post(`${AUTH_PREFIX}/activate`, body);
  }

  public resetPasswordRequest(email: string): Observable<ConfirmResponse> {
    return this.post(`${AUTH_PREFIX}/resetPasswordRequest`, { email });
  }

  public resetPassword(
    body: ResetPasswordRequest,
  ): Observable<ConfirmResponse> {
    return this.post(`${AUTH_PREFIX}/resetPassword`, body);
  }

  public logout(): Observable<ConfirmResponse> {
    return this.post(`${AUTH_PREFIX}/logout`);
  }
}
